import { render, staticRenderFns } from "./SourceTemplate.vue?vue&type=template&id=77beba52&"
import script from "./SourceTemplate.vue?vue&type=script&lang=ts&"
export * from "./SourceTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports